var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-iframe-wrapper"},[_c('iframe',{staticClass:"link-iframe",attrs:{"marginWidth":"0","marginHeight":"0","scrolling":"auto","frameBorder":"0","width":"100%","src":_vm.src || _vm.linkSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }